
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Embryo Grading</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style6" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>-->
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal">{{TitleText}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Day 1</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-4">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                          Count
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          OutCome
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC1Controller">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.EmbryoCount}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.Grade1}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">

            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>
                      <!--<th rowspan="5" class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">

                      </th>-->

                      <th class="font-weight-normal width-70px padding-left-0px padding-right-0px background-primary padding-top-2px text-align-center padding-bottom-2px font-family">

                      </th>

                      <th class="font-weight-normal background-primary padding-left-0px padding-top-2px padding-bottom-2px font-family text-align-center">
                        Embryo Count
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Blastomere Count
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Cell Count
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Cell Stage
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Stage
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Grade
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Frozen
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Discarded
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Transfer
                      </th>

                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC2Controller">
                      <th class="font-family width-70px padding-left-0px padding-right-0px padding-top-2px padding-bottom-2px text-align-left">
                        Day 2
                      </th>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.EmbryoCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Grade1}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.FrozenCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.DiscardedCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TransferCount}}
                      </td>
                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC3Controller">
                      <th class="font-family width-70px padding-left-0px padding-right-0px padding-top-2px padding-bottom-2px text-align-left">
                        Day 3
                      </th>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.EmbryoCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellStage}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Grade1}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.FrozenCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.DiscardedCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TransferCount}}
                      </td>
                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC4Controller">
                      <th class="font-family width-70px padding-left-0px padding-right-0px padding-top-2px padding-bottom-2px text-align-left">
                        Day 4
                      </th>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.EmbryoCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellStage}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Grade1}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.FrozenCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.DiscardedCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TransferCount}}
                      </td>
                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC5Controller">
                      <th class="font-family width-70px padding-left-0px padding-right-0px padding-top-2px padding-bottom-2px text-align-left">
                        Day 5
                      </th>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.EmbryoCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellStage}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <!--{{l.Grade1}}/{{l.Grade1}}-->
                        {{l.Grade1}} {{l.Grade2}}
                        <!--<label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><div>{{l.Grade2}}</div>-->
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.FrozenCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.DiscardedCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TransferCount}}
                      </td>
                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleDOC6Controller">
                      <th class="font-family width-70px padding-left-0px padding-right-0px padding-top-2px padding-bottom-2px text-align-left">
                        Day 6
                      </th>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.EmbryoCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellStage}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Grade1}} {{l.Grade2}}
                        <!--<label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><div>{{l.Grade2}}</div>-->
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.FrozenCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.DiscardedCount}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TransferCount}}
                      </td>
                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-8">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family" *ngIf="DOC=='1'">
                          Count
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center" *ngIf="DOC=='5' || DOC=='6'">
                          Blastomere Count
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC=='2' || DOC=='3' || DOC=='4'">
                          Embryo Count
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC=='2' || DOC=='3'">
                          Cell Count
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC=='4'">
                          Cell Stage
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC=='5' || DOC=='6'">
                          Stage
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC=='1'">
                          Outcome
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC!== '1'">
                          Grade
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC!=='1'">
                          Frozen
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC!=='1'">
                          Discarded
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family" *ngIf="DOC!=='1'">
                          Transfer
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.EmbryoCount}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" *ngIf="DOC=='2' || DOC=='3'">
                          {{l.CellCount}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" *ngIf="DOC=='4'">
                          {{l.CellStage}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px">
                          <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><div *ngIf="DOC!=='4'">{{l.Grade2}} </div>


                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" *ngIf="DOC!=='1'">
                          {{l.FrozenCount}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" *ngIf="DOC!=='1'">
                          {{l.DiscardedCount}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" *ngIf="DOC!=='1'">
                          {{l.TransferCount}}
                        </td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>-->


      </div>
    </div>
  </div>
</div>

